export class FindAllProjectMembersError {
  public static readonly type =
    '[Project/ProjectMembers/List] FindAllProjectMembersError';
  constructor(public readonly error: Error) {}
}
